import {
  EMPTY,
  Observable,
  combineLatest,
  distinctUntilChanged,
  interval,
  map,
  switchMap,
} from 'rxjs';

/** Releitura da aba sem tempo real (ticket recusado, hub fora, rede): enquanto há versão na fila ou gerando. */
export const BRIEFING_POLL_OFFLINE_MS = 8000;

/** Consulta de segurança com o tempo real conectado: evento perdido acontece, e a geração não pode parar na tela. */
export const BRIEFING_POLL_SAFETY_MS = 30000;

/**
 * Intervalo da releitura do briefing: nenhum sem versão ativa; 8 s sem tempo real; 30 s com ele (segurança).
 * `status` é o `RealtimeStatus` do `RealtimeService` (só `connected` conta como conectado).
 */
export function briefingPollInterval(hasActiveVersion: boolean, status: string): number | null {
  if (!hasActiveVersion) return null;
  return status === 'connected' ? BRIEFING_POLL_SAFETY_MS : BRIEFING_POLL_OFFLINE_MS;
}

/**
 * Emite quando a aba deve refazer o GET. Recomeça a contagem quando muda a situação (versão ativa ou conexão) e para
 * quando não há versão ativa. Quem assina relê pelo mesmo `load(true)` do tempo real, que já descarta a resposta
 * anterior (só a releitura mais nova é aplicada).
 */
export function briefingPoll$(
  hasActiveVersion$: Observable<boolean>,
  status$: Observable<string>
): Observable<void> {
  return combineLatest([hasActiveVersion$, status$]).pipe(
    map(([active, status]) => briefingPollInterval(active, status)),
    distinctUntilChanged(),
    switchMap(period => (period === null ? EMPTY : interval(period))),
    map(() => undefined)
  );
}
